import { render, staticRenderFns } from "./DevaluationsItemWithoutStore.vue?vue&type=template&id=0282915a&"
import script from "./DevaluationsItemWithoutStore.vue?vue&type=script&lang=js&"
export * from "./DevaluationsItemWithoutStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports